import { render } from "./NewReport.vue?vue&type=template&id=35e08cde"
import script from "./NewReport.vue?vue&type=script&lang=js"
export * from "./NewReport.vue?vue&type=script&lang=js"

import "./NewReport.vue?vue&type=style&index=0&id=35e08cde&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__